import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TitleStyled = styled.h4`
  margin: 1.5rem;
  font-size: 2rem;
  line-height: 2.8rem;
`;

export const MessageStyled = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  margin: 0;
  max-width: 75rem;
`;

export const InfoBlobWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 4rem;
  box-sizing: border-box;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 4rem 10rem 6rem;
`;
